import { publish } from './publish';

export interface NavigateDataType {
  to: string;
  replace: boolean;
}

export const MFE_NAVIGATE_EVENT = 'sxm_mfe_navigate';

export const navigate = ({
  to,
  queries,
  replace = false,
}: {
  to: string;
  queries?: { [key: string]: any };
  replace?: boolean;
}) => {
  publish<NavigateDataType>(MFE_NAVIGATE_EVENT, {
    to: queries ? `${to}?${new URLSearchParams(queries).toString()}` : to,
    replace,
  });
};
